import { PromoCode } from "../types/promocode.data";
import { useAppSelector } from '../../../redux';
import { PROMOCODE_STORE_NAME } from "../../../contants/stores";
import { formatDate } from "../../../utils/helpers";
import Table from "../../../components/Table/Table";
import { search } from "../actions/propmoCode.actions";
import { useEffect, useState } from "react";

export const PromoCodesList = (props: any) => {
  const query = useAppSelector(state => state[PROMOCODE_STORE_NAME].searchQuery)
  // const promoCodes = useAppSelector(state => state[PROMOCODE_STORE_NAME].promoCodes);
  const headers = ["Title", "Expires at", "Discount", "Order type", "User type", "Action"];
  const [codes, setCodes] = useState(props.promoCodes);

  // Use pagination props from parent
  const currentPage = props.currentPage || 1;
  const setCurrentPage = props.setCurrentPage;
  const rowsPerPage = props.rowsPerPage || 10;
  const setRowsPerPage = props.setRowsPerPage;
  const totalCount = props.totalCount || 0;
  const hasActiveFilters = props.hasActiveFilters || false;

  useEffect(() => {
    updateSearchList()
  }, [props.promoCodes])

  useEffect(() => {
    updateSearchList()
  }, [query]);

  const updateSearchList = () => {
    if (!query.length) {
      setCodes(props.promoCodes);
    } else {
      setCodes(search(query));
    }
  }

  return (
    <>
      {query.length && !codes.length ?
        <div className="w-full order-1 flex-1 bg-white rounded-lg m-4 text-xs">
          No results found
        </div> :
        <>
          <Table headers={headers}>
            {codes && codes?.map((code: PromoCode) => (
              <tr className="bg-white border-b hover:bg-gray-50 text-xs" key={code?.id}>
                <th scope="row" className="flex items-center py-4 px-6 text-gray-900 whitespace-nowra text-xs">
                  <div className="">
                    {/* <div className="text-base font-semibold">{code?.title}</div> */}
                    <div className="flex items-center">
                      <div className={`h-2.5 w-2.5 rounded-full bg-${code?.isPromoCodeActive ? "green-400" : "red-500"} mr-2`}></div>
                      <div className="text-sm font-semibold text-gray-700">{code?.title}</div>
                    </div>
                    <div className="font-normal text-gray-500">{formatDate(code?.createdAt)}</div>
                  </div>
                </th>
                <td className="py-4 px-6">
                  {formatDate(code?.expiresAt)}
                </td>
                <td className="py-4 px-6">
                  <p className="text-xs font-semibold text-gray-700">{code?.discount?.on}</p>
                  <p className="font-normal text-gray-500">{code?.discount?.value?.toFixed(2)} {code?.discount?.type === 'PERCENTAGE' ? ' %' : ' KD'}</p>
                </td>
                <td className="py-4 px-6">
                  {code?.orderType}
                </td>
                <td className="py-4 px-6">
                  <p className="text-xs font-semibold text-gray-700">{code?.user?.type}</p>
                  <p className="font-normal text-gray-500">{code?.user?.reference ?? ''}</p>
                </td>
                <td className="flex gap-2 py-4 px-6">
                  <button
                    onClick={() => props.onPressItem(code, 'EDIT')}
                    data-modal-toggle="editUserModal" className="font-medium text-blue-600 hover:underline">Edit</button>
                  <button
                    onClick={() => props.onPressItem(code, 'DELETE')}
                    data-modal-toggle="editUserModal" className="font-medium text-red-600 hover:underline">Delete</button>
                </td>
              </tr>
            ))}
          </Table>
          {/* Pagination Controls - show when not searching (filters can be active) */}
          {query.trim().length === 0 && (
            <div className="flex flex-col md:flex-row md:items-center md:justify-between mt-4 gap-2">
              <div className="flex items-center gap-2">
                <span className="text-xs text-gray-600">Rows per page:</span>
                <select
                  className="border border-gray-300 rounded px-2 py-1 text-xs"
                  value={rowsPerPage}
                  onChange={e => { 
                    if (setRowsPerPage) setRowsPerPage(Number(e.target.value)); 
                    if (setCurrentPage) setCurrentPage(1); 
                  }}
                >
                  {[5, 10, 20, 50, 100].map(n => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </select>
              </div>
              <div className="flex items-center gap-2">
                {/* Jump -10 pages */}
                <button
                  className="px-2 py-1 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 text-xs"
                  onClick={() => setCurrentPage && setCurrentPage(Math.max(1, currentPage - 10))}
                  disabled={currentPage <= 10}
                >
                  &#171;
                </button>
                {/* Previous page */}
                <button
                  className="px-2 py-1 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 text-xs"
                  onClick={() => setCurrentPage && setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                {/* Current page */}
                <button
                  className="px-2 py-1 rounded text-xs bg-blue-600 text-white cursor-default"
                  disabled
                >
                  {currentPage}
                </button>
                {/* Next page (show only if not last page) */}
                {currentPage < Math.ceil(totalCount / rowsPerPage) && (
                  <button
                    className="px-2 py-1 rounded text-xs bg-gray-200 text-gray-700 hover:bg-gray-300"
                    onClick={() => setCurrentPage && setCurrentPage(currentPage + 1)}
                  >
                    {currentPage + 1}
                  </button>
                )}
                {/* Next page button */}
                <button
                  className="px-2 py-1 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 text-xs"
                  onClick={() => setCurrentPage && setCurrentPage(currentPage + 1)}
                  disabled={currentPage >= Math.ceil(totalCount / rowsPerPage)}
                >
                  Next
                </button>
                {/* Jump +10 pages */}
                <button
                  className="px-2 py-1 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 text-xs"
                  onClick={() => setCurrentPage && setCurrentPage(Math.min(Math.ceil(totalCount / rowsPerPage), currentPage + 10))}
                  disabled={currentPage >= Math.ceil(totalCount / rowsPerPage)}
                >
                  &#187;
                </button>
              </div>
              <div className="text-xs text-gray-600">
                {query.trim().length > 0 ? (
                  `Found ${codes.length} search results`
                ) : hasActiveFilters ? (
                  `Showing ${codes.length} of ${totalCount} filtered results (Page ${currentPage})`
                ) : (
                  `Showing ${codes.length} of ${totalCount} (Page ${currentPage})`
                )}
              </div>
            </div>
          )}
          {/* Show search results info when searching */}
          {query.trim().length > 0 && (
            <div className="text-xs text-gray-600 mt-4 text-center">
              Found {codes.length} search results for "{query}"
            </div>
          )}
          {/* Show filter info when filtering */}
          {hasActiveFilters && query.trim().length === 0 && (
            <div className="text-xs text-gray-600 mt-4 text-center">
              Showing {totalCount} filtered results across {Math.ceil(totalCount / rowsPerPage)} pages
            </div>
          )}
        </>
      }
    </>
  );
}